import { getAboutTravelPass } from "../../../app/api/getCmsAboutTravelPass";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICmsAboutTravelPass } from "../../../Orchestrator/Types/Interface/ICMSOffers";

class GetCmsAboutTravelPassAction extends BaseAction<ICmsAboutTravelPass | null, void> {
  override async run(): Promise<ICmsAboutTravelPass | null> {
    let result: ICmsAboutTravelPass | null = null;
    try {
      const response = await getAboutTravelPass();

      if (response.status === "ok" && response.answer) {
        result = response?.answer?.data;
      } else {
        console.warn("Failed to fetch about travel pass.");
      }
    } catch (error: any) {
      console.error("Error fetching about travel pass:", error);
    } finally {
      updateRecoilState("cmsAboutPassDetailAtom", result);
      return result;
    }
  }
}

export const getCmsAboutTravelPassAction = new GetCmsAboutTravelPassAction();
